import React from 'react';
import './Navbar.css';
import logo from '../assets/img/logo1.png';
import toggler from '../assets/img/menu-button.svg'
import callIcon from '../assets/img/speech-bubble.svg'
import { Link } from 'react-router-dom';

class Navbar extends React.Component {
  constructor() {
    super();

    this.state = {
      mobileNavEnabled: false
    }
  }

  scrollToSection(view) {
    if (view) {
      let elem = document.getElementById(view);
      elem.scrollIntoView();
    }

    if (this.state.mobileNavEnabled) {
      this.enableDisableMobileNav();
    }
  }

  enableDisableMobileNav() {
    let { mobileNavEnabled } = this.state;
    this.setState({mobileNavEnabled: !mobileNavEnabled})
  }

  render() {
    let links;
    let mobileLinks;

    if (this.props.location.pathname === '/gabinet' || this.props.location.pathname.startsWith("/oferta")) {
      links = (
        <div className="nav-links nav-links--center">
          <Link to="/">strona główna</Link>
        </div>
      );

      mobileLinks = (
        <ul>
          <li onClick={() => this.enableDisableMobileNav()}><Link to="/">powrót</Link></li>
        </ul>
      )
    } else {
      links = (
        <div className="nav-links">
          <span onClick={() => this.scrollToSection("offer")}>oferta</span>
          <span onClick={() => this.scrollToSection("promo")}>promocje</span>
          <Link to="/gabinet">o gabinecie</Link>
          <span onClick={() => this.scrollToSection("contact")}>kontakt</span>
        </div>
      )

      mobileLinks = (
          <ul>
            <li onClick={() => this.scrollToSection("offer")}>oferta</li>
            <li onClick={() => this.scrollToSection("promo")}>promocje</li>
            <li onClick={() => this.scrollToSection()}><Link to="/gabinet">o gabinecie</Link></li>
            <li onClick={() => this.scrollToSection("contact")}>kontakt</li>
          </ul>
        )
    }

    let mobileNav;

    if (this.state.mobileNavEnabled) {
      mobileNav = (
        <nav className="nav-mobile">
          <div className="nav-mobile-btn-close" onClick={() => this.enableDisableMobileNav()}>x</div>
          {mobileLinks}
        </nav>
      )
    }

    return (
      <>
        <nav>
          <div className="container">
            <a href="#">
              <img className="nav-logo" src={logo} alt="Logo podolog"></img>
            </a>

            {links}

            <div className="nav-toggler" onClick={() => this.enableDisableMobileNav()}>
              <img src={toggler}></img>
            </div>

            <div className="nav-call">
              umów wizytę<a href="tel:+48 735 049 669"><br></br>735 049 669</a>
            </div>
          </div>

          <a href="tel:+48 735 049 669" className="nav-call-bubble">
            <img src={callIcon}></img>
          </a>
        </nav>

        {mobileNav}
      </>
    );
  }
}

export default Navbar;

